import { render, staticRenderFns } from "./PreguntasHistorialDialog.vue?vue&type=template&id=491dcd68&scoped=true&"
import script from "./PreguntasHistorialDialog.vue?vue&type=script&lang=js&"
export * from "./PreguntasHistorialDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491dcd68",
  null
  
)

export default component.exports